/* eslint-disable no-unused-vars */
import React, { FC, memo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button
} from '@material-ui/core';

const useStyles = makeStyles({
  root: {}
});

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (serialNo: string) => void;
}

const Component: FC<Props> = ({ open, onClose, onSubmit }) => {
  const classes = useStyles();
  const [serialNo, setSerialNo] = useState('');

  const handleSubmit = () => {
    onSubmit(serialNo);
    setSerialNo('');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={'sm'}
      disableBackdropClick
    >
      <DialogTitle id="serial-dialog-title">
        Enter New Serial No. (Required)
      </DialogTitle>
      <DialogContent style={{ padding: '1.5rem' }}>
        <TextField
          fullWidth
          label="Serial No"
          value={serialNo}
          variant="outlined"
          onChange={(e) => setSerialNo(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained">
          Replace Listing
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const RmaChangeSerialDropdown = memo(Component);
